// Booking flow virtual pageview tracking for GTM/GA4
//
// Fires virtual_pageview events on booking flow step transitions.
// Works with Turbo Drive navigations and handles edge cases like
// Turbo Frame interactions and full page reloads.
//
// GTM should have a trigger for "virtual_pageview" custom event that
// fires a GA4 page_view tag for these booking funnel steps.

const VIRTUAL_PAGEVIEW_EVENT = "virtual_pageview"

const BOOKING_STEPS = {
  "/flow/booking/personal_info": { step: "personal_info", number: 1, name: "Personal Info" },
  "/flow/booking/pets": { step: "pets", number: 2, name: "Select Pets" },
  "/flow/booking/guest_services": { step: "guest_services", number: 3, name: "Guest Services" },
  "/flow/booking/reviews": { step: "review", number: 4, name: "Review" },
  "/flow/booking/confirms": { step: "confirmation", number: 5, name: "Confirmation" }
}

// Track last path to prevent duplicate fires (Option B from analysis)
let lastTrackedPath = null

function getBookingStep(pathname) {
  // Match the base path (ignore query params, order_id segments)
  for (const [basePath, stepData] of Object.entries(BOOKING_STEPS)) {
    if (pathname.includes(basePath)) {
      return stepData
    }
  }
  return null
}

function trackBookingStep() {
  const pathname = window.location.pathname
  const step = getBookingStep(pathname)

  // Only track booking flow pages
  if (!step) return

  // Prevent duplicate fires for same path (handles SPA re-renders)
  if (pathname === lastTrackedPath) return

  lastTrackedPath = pathname

  // Initialize dataLayer if needed (events queue for when GTM loads)
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: VIRTUAL_PAGEVIEW_EVENT,
    page_location: window.location.href,
    page_path: pathname,
    page_title: document.title,
    booking_step: step.step,
    booking_step_number: step.number,
    booking_step_name: step.name
  })
}

// Track on Turbo Drive navigation (main page transitions)
document.addEventListener("turbo:load", trackBookingStep)

// Track on Turbo Frame render (catches frame-based navigations)
document.addEventListener("turbo:frame-render", trackBookingStep)

// Track on Turbo Stream render (catches stream updates that change URL)
document.addEventListener("turbo:render", () => {
  // Small delay to ensure URL has updated
  requestAnimationFrame(trackBookingStep)
})

export {}
